'use strict';

/**
 * @param {Event|null|undefined} e
 * @returns {boolean}
 */
function isEnterKeyUpEvent(e) {
	return e?.type === 'keyup' && e?.which === 13;
}

module.exports = {
	isEnterKeyUpEvent,
};
